module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.homeLoan) ? _c('div', {
    ref: "mainDiagram",
    on: {
      "mousemove": function($event) {
        return _vm.drag($event)
      },
      "mouseup": function($event) {
        return _vm.endDrag($event)
      }
    }
  }, [_vm._l((_vm.homeLoan.groups), function(group, groupIndex) {
    return _c('div', {
      key: groupIndex,
      staticClass: "xxxray",
      staticStyle: {
        "padding": "2px",
        "margin-bottom": "5px",
        "overflow-x": "scroll"
      }
    }, [_c('div', {
      staticStyle: {
        "color": "#aaa",
        "font-size": "12px",
        "padding": "2px"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.groupTitle(groupIndex)) + ": " + _vm._s(_vm._f("currency")(_vm.totalLoans(group))) + " total.\n        ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "position": "relative"
      }
    }, [_vm._l((group.loans), function(loan, loanIndex) {
      return _c('div', {
        key: 'loan' + loanIndex,
        staticClass: "loan no-select",
        class: {
          dragging: loan._dragStart && loan._dragMode != 'splitter'
        },
        staticStyle: {
          "display": "flex"
        },
        style: (_vm.loanStyle(loan, group)),
        on: {
          "mousedown": function($event) {
            return _vm.startLoanDrag($event, loan)
          },
          "dblclick": function($event) {
            return _vm.editLoan(loan)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "flex-grow": "1",
          "padding": "4px 6px",
          "border": "solid 3px rgba(0,0,0,0.1)",
          "margin": "2px",
          "border-radius": "5px",
          "color": "white",
          "font-weight": "500"
        },
        style: (_vm.loanBarStyle(loan))
      }, [_c('div', {
        staticStyle: {
          "float": "right",
          "margin-top": "-4px"
        }
      }, [_c('v-menu', {
        attrs: {
          "offset-y": "",
          "left": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-icon', _vm._g({
              attrs: {
                "color": "white",
                "small": ""
              }
            }, on), [_vm._v("keyboard_arrow_down")])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.editLoan(loan)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Edit Loan")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.addLoan(loan)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Add Loan")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.split(loan)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Split Loan")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.split(loan, true)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Duplicate Loan")])], 1), _vm._v(" "), (group.loans.length > 1) ? _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.deleteLoan(loan)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Delete Loan")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v("\n\n                    " + _vm._s(_vm.loanTitle(loan)) + " "), (loan.rate) ? _c('span', {
        staticStyle: {
          "color": "white",
          "font-weight": "300",
          "xfont-size": "14px"
        }
      }, [_vm._v("@ "), _c('EditableText', {
        attrs: {
          "dark": ""
        },
        model: {
          value: (loan.rate),
          callback: function($$v) {
            _vm.$set(loan, "rate", $$v)
          },
          expression: "loan.rate"
        }
      }), _vm._v("%")], 1) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "white-space": "nowrap",
          "display": "inline-block",
          "line-height": "16px",
          "xfont-size": "14px",
          "font-weight": "300"
        }
      }, [_c('LabelMenu', {
        attrs: {
          "underline": "white",
          "menus": _vm.loanPurposeOptions
        },
        model: {
          value: (loan.investment),
          callback: function($$v) {
            _vm.$set(loan, "investment", $$v)
          },
          expression: "loan.investment"
        }
      }), _vm._v(" "), _c('LabelMenu', {
        attrs: {
          "underline": "white",
          "menus": _vm.fixedOptions
        },
        model: {
          value: (loan.fixed),
          callback: function($$v) {
            _vm.$set(loan, "fixed", $$v)
          },
          expression: "loan.fixed"
        }
      }), _vm._v(" "), (loan.fixed) ? _c('LabelMenu', {
        attrs: {
          "underline": "white",
          "menus": _vm.rateLockOptions
        },
        model: {
          value: (loan.rateLock),
          callback: function($$v) {
            _vm.$set(loan, "rateLock", $$v)
          },
          expression: "loan.rateLock"
        }
      }) : _vm._e(), _vm._v(" "), _c('LabelMenu', {
        attrs: {
          "underline": "white",
          "menus": _vm.ioOptions
        },
        model: {
          value: (loan.io),
          callback: function($$v) {
            _vm.$set(loan, "io", $$v)
          },
          expression: "loan.io"
        }
      })], 1)]), _vm._v(" "), _c('div', {
        key: 'loanHandle' + loanIndex,
        staticClass: "loan-handle mt-1",
        class: {
          dragging: loan._dragStart && loan._dragMode == 'splitter'
        },
        attrs: {
          "color": "grey"
        },
        on: {
          "mousedown": function($event) {
            return _vm.$set(loan, '_dragMode', 'splitter')
          }
        }
      })])
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "8px 2px 8px 5px",
        "width": "70px"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.getLVR(group)) + "%\n            ")])], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "width": "100%"
      }
    }, _vm._l((group.properties), function(property, propertyIndex) {
      return _c('div', {
        key: 'property' + propertyIndex,
        staticClass: "property no-select",
        class: {
          dragging: Boolean(property._dragStart)
        },
        staticStyle: {
          "color": "white",
          "display": "flex",
          "border": "solid 3px rgba(0,0,0,0.1)",
          "margin": "2px",
          "border-radius": "5px",
          "flex-grow": "1"
        },
        style: (_vm.propertyStyle(property, group)),
        on: {
          "mousedown": function($event) {
            return _vm.startPropertyDrag($event, property)
          },
          "dblclick": function($event) {
            return _vm.editProperty(property)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "padding": "4px 6px",
          "font-weight": "500",
          "flex-grow": "1"
        }
      }, [_c('div', {
        staticStyle: {
          "float": "right",
          "margin-top": "-4px"
        }
      }, [_c('v-menu', {
        attrs: {
          "offset-y": "",
          "left": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-icon', _vm._g({
              attrs: {
                "color": "white",
                "small": ""
              }
            }, on), [_vm._v("keyboard_arrow_down")])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.addProperty(property)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Add Property")])], 1), _vm._v(" "), (group.properties.length > 1) ? _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.deleteProperty(property)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Delete Property")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v("\n\n                    " + _vm._s(_vm._f("thousands")(property.value)) + "\n                    "), _c('span', {
        staticStyle: {
          "font-weight": "300",
          "xfont-size": "14px"
        }
      }, [_c('LabelMenu', {
        attrs: {
          "underline": "white",
          "menus": _vm.existingPropertyOptions
        },
        model: {
          value: (property.existing),
          callback: function($$v) {
            _vm.$set(property, "existing", $$v)
          },
          expression: "property.existing"
        }
      }), _vm._v(" "), _c('LabelMenu', {
        attrs: {
          "underline": "white",
          "menus": _vm.investmentPropertyOptions
        },
        model: {
          value: (property.investment),
          callback: function($$v) {
            _vm.$set(property, "investment", $$v)
          },
          expression: "property.investment"
        }
      }), _vm._v(" "), _c('LabelMenu', {
        attrs: {
          "underline": "white",
          "menus": _vm.propertyTypes
        },
        model: {
          value: (property.type),
          callback: function($$v) {
            _vm.$set(property, "type", $$v)
          },
          expression: "property.type"
        }
      })], 1), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-weight": "300"
        }
      }, [_vm._v(_vm._s(property.address))])])])
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-links"
  }, [_c('a', {
    staticClass: "bottom-link",
    on: {
      "click": _vm.addGroup
    }
  }, [_vm._v("Add Group")]), _vm._v(" |\n        "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('a', _vm._g({
          staticClass: "bottom-link",
          on: {
            "click": function($event) {}
          }
        }, on), [_vm._v("Delete Group")])]
      }
    }], null, false, 4058488063)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.homeLoan.groups), function(group, groupIndex) {
    return _c('v-list-item', {
      key: 'dg' + groupIndex,
      on: {
        "click": function($event) {
          return _vm.deleteGroup(groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.groupTitle(groupIndex)))])], 1)
  }), 1)], 1), _vm._v(" |\n        "), _c('a', {
    staticClass: "bottom-link",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("Copy")]), _vm._v(" | \n        "), _c('a', {
    staticClass: "bottom-link",
    on: {
      "click": function($event) {
        return _vm.$set(_vm.homeLoan, 'summaryVisible', !_vm.homeLoan.summaryVisible)
      }
    }
  }, [_vm._v(_vm._s(_vm.homeLoan.summaryVisible ? 'Hide Summary' : 'Summary'))]), _vm._v(" |\n        "), _c('a', {
    staticClass: "bottom-link",
    on: {
      "click": function($event) {
        return _vm.$set(_vm.homeLoan, 'locked', !_vm.homeLoan.locked)
      }
    }
  }, [_vm._v(_vm._s(_vm.homeLoan.locked ? 'Unlock' : 'Lock'))]), _vm._v(" |\n        "), _c('a', {
    staticClass: "bottom-link",
    on: {
      "click": _vm.help
    }
  }, [_vm._v("Help")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "visibility": "hidden"
    }
  }, [_c('Timer', {
    attrs: {
      "seconds": 9,
      "watch": _vm.homeLoan
    },
    on: {
      "run": _vm.saveDiagram
    }
  })], 1)], 1), _vm._v(" "), (_vm.homeLoan.summaryVisible) ? _c('div', {
    staticClass: "summary"
  }, _vm._l((_vm.shortSummary), function(attribute) {
    return _c('div', {
      key: attribute.name,
      attrs: {
        "title": attribute.name
      }
    }, [_vm._v("\n            " + _vm._s(attribute.title) + ": " + _vm._s(attribute.value) + "\n        ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "simple",
    staticClass: "simple-version-div",
    staticStyle: {
      "font-size": "16px",
      "max-width": "800px"
    }
  }, [_vm._l((_vm.homeLoan.groups), function(group, groupIndex) {
    return [_c('div', {
      key: 'gh' + groupIndex,
      staticStyle: {
        "color": "#888",
        "font-size": "14px",
        "padding": "2px"
      }
    }, [_vm._v(_vm._s(_vm.groupTitle(groupIndex)) + ": " + _vm._s(_vm._f("currency")(_vm.totalLoans(group))) + " total.")]), _vm._v(" "), _c('table', {
      key: 'sgl' + groupIndex,
      attrs: {
        "cellspacing": "5",
        "width": "100%"
      }
    }, [_c('tr', [_vm._l((group.loans), function(loan, loanIndex) {
      return _c('td', {
        key: 'sl' + loanIndex,
        staticStyle: {
          "color": "white",
          "border-radius": "5px",
          "padding": "5px",
          "min-width": "150px"
        },
        style: (_vm.loanBarStyle(loan, group)),
        attrs: {
          "width": _vm.percentage(loan, group) + '%',
          "valign": "top"
        }
      }, [_c('strong', [_vm._v(_vm._s(_vm.loanTitle(loan)))]), _vm._v(" " + _vm._s(_vm.loanDetails(loan)) + "\n                ")])
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "5px"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.getLVR(group)) + "%\n                ")])], 2)]), _vm._v(" "), _c('table', {
      key: 'sgp' + groupIndex,
      staticStyle: {
        "margin-top": "-5px"
      },
      attrs: {
        "cellspacing": "5",
        "width": "100%"
      }
    }, [_c('tr', _vm._l((group.properties), function(property, propertyIndex) {
      return _c('td', {
        key: 'sp' + propertyIndex,
        staticStyle: {
          "color": "white",
          "border-radius": "5px",
          "padding": "5px",
          "min-width": "150px"
        },
        style: (_vm.propertyColour(property, group) + 'width:' + _vm.percentage(property, group) + '%'),
        attrs: {
          "valign": "top"
        }
      }, [_c('strong', [_vm._v(_vm._s(_vm._f("currency")(property.value)))]), _vm._v(" " + _vm._s(_vm.propertyDetails(property)) + "\n                ")])
    }), 0)])]
  })], 2), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "title": "Loan Details",
      "settings": _vm.loanDialog.settings,
      "save-on-enter": ""
    },
    on: {
      "save": function($event) {
        return _vm.saveLoan(_vm.loanDialog.loan)
      }
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "blue--text text--darken-2",
    staticStyle: {
      "margin-top": "-15px"
    },
    style: ({
      'visibility': _vm.activeLoanPayment ? 'visible' : 'hidden'
    })
  }, [(_vm.loanDialog.loan.io) ? _c('span', [_vm._v("IO ")]) : _vm._e(), _vm._v("\n                Repayment " + _vm._s(_vm._f("currency")(_vm.activeLoanPayment)) + "pm\n                 | " + _vm._s(_vm._f("currency")(_vm.activeLoanPayment * 12 / 52)) + "pw\n\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('currency-box', {
    ref: "focus",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "Base Amount"
    },
    model: {
      value: (_vm.loanDialog.loan.amount),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "amount", _vm._n($$v))
      },
      expression: "loanDialog.loan.amount"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "items": _vm.lmiOptions,
      "label": "LMI"
    },
    model: {
      value: (_vm.loanDialog.loan.lmiType),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "lmiType", $$v)
      },
      expression: "loanDialog.loan.lmiType"
    }
  }), _vm._v(" "), _c('currency-box', {
    attrs: {
      "label": "Est LMI"
    },
    model: {
      value: (_vm.loanDialog.loan.lmi),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "lmi", _vm._n($$v))
      },
      expression: "loanDialog.loan.lmi"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "Rate %"
    },
    model: {
      value: (_vm.loanDialog.loan.rate),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "rate", _vm._n($$v))
      },
      expression: "loanDialog.loan.rate"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "items": _vm.yearsOptions,
      "label": "Years"
    },
    model: {
      value: (_vm.loanDialog.loan.years),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "years", $$v)
      },
      expression: "loanDialog.loan.years"
    }
  }), _vm._v(" "), _c('currency-box', {
    attrs: {
      "label": "New Money (if different)"
    },
    model: {
      value: (_vm.loanDialog.loan.newMoney),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "newMoney", $$v)
      },
      expression: "loanDialog.loan.newMoney"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-2",
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap",
      "gap": "15px"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Package",
      "hide-details": ""
    },
    model: {
      value: (_vm.loanDialog.loan.package),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "package", $$v)
      },
      expression: "loanDialog.loan.package"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Special",
      "hide-details": ""
    },
    model: {
      value: (_vm.loanDialog.loan.special),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "special", $$v)
      },
      expression: "loanDialog.loan.special"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Investment",
      "hide-details": ""
    },
    model: {
      value: (_vm.loanDialog.loan.investment),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "investment", $$v)
      },
      expression: "loanDialog.loan.investment"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Existing Debt Keeping",
      "hide-details": ""
    },
    model: {
      value: (_vm.loanDialog.loan.existing),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "existing", $$v)
      },
      expression: "loanDialog.loan.existing"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-select', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "items": _vm.fixedOptions,
      "label": (_vm.loanDialog.loan.fixed ? 'Fixed Period' : 'Fixed or Variable')
    },
    model: {
      value: (_vm.loanDialog.loan.fixed),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "fixed", _vm._n($$v))
      },
      expression: "loanDialog.loan.fixed"
    }
  }), _vm._v(" "), (_vm.loanDialog.loan.fixed) ? _c('div', {
    staticStyle: {
      "flex-basis": "180px"
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Rate Lock"
    },
    model: {
      value: (_vm.loanDialog.loan.rateLock),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "rateLock", $$v)
      },
      expression: "loanDialog.loan.rateLock"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.ioOptions,
      "label": (_vm.loanDialog.loan.io ? 'Interest Only Period' : 'P&I or IO')
    },
    model: {
      value: (_vm.loanDialog.loan.io),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "io", _vm._n($$v))
      },
      expression: "loanDialog.loan.io"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-text-field', {
    attrs: {
      "label": "Product",
      "hint": "Include any offers or rebates"
    },
    model: {
      value: (_vm.loanDialog.loan.product),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "product", $$v)
      },
      expression: "loanDialog.loan.product"
    }
  })], 1)]), _vm._v(" "), _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "slot": "footer"
    },
    on: {
      "delete": function($event) {
        _vm.deleteLoan(_vm.loanDialog.loan._originalLoan);
        _vm.loanDialog.settings.visible = false;
      }
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "title": "Propety Details",
      "settings": _vm.propertyDialog.settings,
      "save-on-enter": ""
    },
    on: {
      "save": function($event) {
        return _vm.saveProperty(_vm.propertyDialog.property)
      }
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('currency-box', {
    ref: "focus",
    attrs: {
      "label": "Value"
    },
    model: {
      value: (_vm.propertyDialog.property.value),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.property, "value", _vm._n($$v))
      },
      expression: "propertyDialog.property.value"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Investment"
    },
    model: {
      value: (_vm.propertyDialog.property.investment),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.property, "investment", $$v)
      },
      expression: "propertyDialog.property.investment"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "label": "Existing"
    },
    model: {
      value: (_vm.propertyDialog.property.existing),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.property, "existing", $$v)
      },
      expression: "propertyDialog.property.existing"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Address"
    },
    model: {
      value: (_vm.propertyDialog.property.address),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.property, "address", $$v)
      },
      expression: "propertyDialog.property.address"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.propertyTypes,
      "label": "Type"
    },
    model: {
      value: (_vm.propertyDialog.property.type),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.property, "type", $$v)
      },
      expression: "propertyDialog.property.type"
    }
  })], 1), _vm._v(" "), (!_vm.homeLoan.locked) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "slot": "footer"
    },
    on: {
      "delete": function($event) {
        _vm.deleteProperty(_vm.propertyDialog.property._originalProperty);
        _vm.propertyDialog.settings.visible = false;
      }
    },
    slot: "footer"
  }) : _vm._e()], 1)], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf61d1e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/HomeLoan.vue
// module id = 2659
// module chunks = 1